import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const UserResetSuccessDialog = ({ open, username, password, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Password Reset Successful</DialogTitle>
      <DialogContent>
        <DialogContentText>
          A new password has been generated for <strong>{username}</strong>.
          <br />
          <br />
          <strong>Password:</strong> <code>{password}</code>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserResetSuccessDialog;
